import React, { useState, useEffect } from "react";
import MagneticButton from "../Miscellaneous/MagneticButton";

const CTAOne = () => {
  const [ctaData, setCtaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Local CTA data
    const localCTA = {
      title: "Let’s Build Something ",
      highlight: "Great Together",
      button: {
        text: "Get In Touch!",
        link: "/contact",
      },
      socials: [
        {
          name: "LinkedIn",
          link: "https://www.linkedin.com/in/imamantripathi/",
        },
        { name: "Instagram", link: "https://instagram.com/aman.css" },
        { name: "X", link: "https://x.com/Imamantripathi1" },
        { name: "GitHub", link: "https://github.com/imamantripathi" },
        { name: "Youtube", link: "https://www.youtube.com/@imamantripathi" },
      ],
    };

    setCtaData(localCTA);
    setLoading(false);
  }, []);

  if (loading) return <p>Loading CTA...</p>;
  if (!ctaData || Object.keys(ctaData).length === 0)
    return <p>Error loading CTA.</p>;

  return (
    <section className="cta border-top border-light-subtle">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-12 col-md-10 col-lg-7">
            <h2 className="title mb-0 mb-md-2">{ctaData.title}</h2>
            <div className="cta-text">
              <span className="line-item">{ctaData.highlight}</span>
              <span className="line"></span>
              <MagneticButton href={ctaData.button?.link}>
                {ctaData.button?.text}
              </MagneticButton>
            </div>

            {/* Socials */}
            <div className="socials mt-5">
              <nav className="nav justify-content-center">
                {ctaData.socials?.length > 0 ? (
                  ctaData.socials.map((social, index) => (
                    <a
                      key={index}
                      className="nav-link swap-icon"
                      href={social.link}
                    >
                      {social.name}{" "}
                      <i className="icon rotate bi bi-arrow-right-short"></i>
                    </a>
                  ))
                ) : (
                  <p>No social links available.</p>
                )}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAOne;
